import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { CodeCodetablePickerProps, codePickersId } from './types';
import { CodeFieldWireKey } from 'app/area/indicator-factors/types-store';
import { SinglePickerCreator } from 'app/area/indicator-factors/common/single-picker-creator';
import { getDisabledValidation } from 'app/area/shared/codetable/item/codetable-item-helpers';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const Unit = (props: CodeCodetablePickerProps) => {

  const { codeItem, codetableOptions, loadCodetableOptions, translation, validation, readOnly } = props;

  const codetableId = codePickersId.unit;
  const codetableKey = CodeFieldWireKey.unit;
  const valueItem = codeItem && codeItem[codetableKey];
  const codeOptions = (!!codetableOptions[codetableKey] && codetableOptions[codetableKey].codes || []) as CodeComplexValue<number>[];
  const currentValidation = !!validation && !!validation[codetableKey] ? validation[codetableKey] : undefined;
  const finalValidation = { ...currentValidation, ...getDisabledValidation(valueItem?.disabled, translation.selected_value_disabled) };

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadCodetableOptions(id, codetableId, loadOptionsParams);
  };

  const onChange = (value: CodeComplexValue<number>) => {
    props.resetValidation(codetableKey, value);
    props.onChange(codetableKey, value);
    props.clearAllValidation(codetableKey);
  };

  const extraFooterButton = manageOptionsButton(translation.manage_options, codetableId);

  return <SinglePickerCreator
    id={codetableKey}
    label={translation.unit}
    valueItem={valueItem?.value ? valueItem : undefined}
    searchRequired={false}
    readOnly={readOnly}
    options={codeOptions}
    fetchingOptions={codetableOptions[codetableKey] && codetableOptions[codetableKey].fetching}
    translation={translation}
    onLoadOptions={onLoadOptions}
    onChange={onChange}
    extraFooterButton={extraFooterButton}
    validation={finalValidation}
  />;
};
